import React from 'react';
import {CONSENT_DATA} from "../../content/consent/Consent";
import {isNotNull} from "../../util/Validators";
import {Checkbox, FormControl, FormControlLabel, Radio, RadioGroup} from "@mui/material";

import "../../App.css";
import "./ConsentForm.css";

export default function ConsentForm(props) {

    const update = props.watch;
    const buildModel = () => {

        const values = {
            employee: null
        };

        CONSENT_DATA.forEach((item) => {
            values[item.name] = {
                checked: false
            }
        })

        return values;
    }

    const [data, setData] = React.useState(buildModel());

    const onUpdate = (obj) => {

        const copy = {...data};

        copy[obj.target.name].checked = !copy[obj.target.name].checked;
        setData(copy);

        update.watch(update.name, copy);
    }

    const handleRadio = (obj) => {

        const copy = {...data};
        copy["employee"] = obj.target.value;

        setData(copy);
        update.watch(update.name, copy);
    }

    const buildOptions = (options) => {

        return <div
                    style={{marginTop: "10px", marginLeft: "20px"}}
                    className={"default-font-color-dark"}
        >
            <FormControl>
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
            >
                {
                    options.map((option, index) => {
                        return <FormControlLabel
                            key={"r_"+index}
                            value={option}
                            name={"employee"}
                            control={<Radio />}
                            label={option}
                            onChange={handleRadio} />
                    })

                }
            </RadioGroup>
        </FormControl></div>
    }

    const buildCheck = (details, idx, onUpdate) => {
        return <div
            key={"chk_"+idx}
            style={{
                padding: "15px 30px 15px 30px"
            }}
        >
                <div
                    style={{
                        textAlign: "left",
                        fontWeight: "bold",
                        fontSize: "18px",
                        marginBottom: "10px"
                    }}
                    className={"default-font-color-dark"}
                >
                    {details.title}
                </div>
                <div
                    style={{
                        display: "flex"
                    }}
                >
                    <div>
                        <Checkbox
                            color={"primary"}
                            name={details.name}
                            checked={data[details.name].checked}
                            onChange={onUpdate}
                        />
                    </div>
                    <div
                        style={{
                            textAlign: "left",
                            marginLeft: "10px"
                        }}
                    >
                        <div className={"default-font-color-dark"}>
                            {details.text}
                        </div>
                        <div>
                            {
                                isNotNull(details.options) ? buildOptions(details.options) : ""
                            }
                        </div>
                    </div>
                </div>
        </div>
    }

    return (
        <React.Fragment>

            <div className={"default-margin-top-xlarge"}>
                    <div className={"default-font-color-dark"}>
                        {
                            CONSENT_DATA.map((item, idx) => {
                                return buildCheck(item, idx, onUpdate);
                            })
                        }
                    </div>
            </div>

        </React.Fragment>
    )

}